/**
 * InappSettings entity class
 */

/**
 * InappSettingsFactory
 * returns InappSettings entity class
 *
 * @class InappSettingsFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.InappSettings} class
 *
 * @ngdoc factory
 * @name mwApp.factory:InappSettingsFactory
 */
/* @ngInject */
export default function InappSettingsFactory ($q, Entity, Type) {
  /* === InappSettings class === */

  /**
   * InappSettings model
   *
   * @class InappSettings
   * @classdesc InappSettings model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.InappSettings} InappSettings entity
   */
  function InappSettings () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  InappSettings.prototype = Object.create(Entity.prototype)
  InappSettings.prototype.constructor = InappSettings

  /* === InappSettings instance methods & fields === */

  Object.assign(InappSettings.prototype, {

    /**
     * instance fields
     *
     * @memberof models.InappSettings#
     * @type {Object}
     */
    _fields: {
      guestModeSettings: {
        enabled: true,
        network: Type.Stump('Network', ['id', 'name']),
        subscription: Type.Stump('Subscription', ['id', 'name'])
      },
      inAppRegistrationSettings: {
        enabled: true,
        network: Type.Stump('Network', ['id', 'name']),
        subscription: Type.Stump('Subscription', ['id', 'name']),
        linkTimeCount: 24,
        linkTimeUnit: Type(String('HOUR'))
      },
      multiorgEnabled: Boolean,
      resetPasswordSettings: {
        resetPasswordEnabled: Boolean
      }
    },

    /**
     * url template
     *
     * @memberof models.InappSettings#
     * @type {String}
     */
    _urlTemplate: 'api/settings/login-options'

  })

  /* === InappSettings static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(InappSettings, Entity)
  InappSettings._name = 'InappSettings'
  InappSettings.init()

  // permissions
  InappSettings.access = {
    view: 'viewNetworkGeneral viewGlobalGeneral |',
    // create: 'createCatchup',
    edit: 'editNetworkGeneral editGlobalGeneral |'
    // delete: 'deleteCatchup'
  }

  // extra
  InappSettings.extra = {
    networks: [Type.Stump('Network', ['id', 'name'])],
    subscriptions: [Type.Stump('Subscription', ['id', 'name'])],
    timeUnits: [String]
  }

  /**
   * Current in-app settings
   */
  InappSettings._current = null

  /**
   * Force load in-app settings
   *
   * @memberof models.InappSettings
   * @return {Promise} promise
   */
  InappSettings.forceLoad = function () {
    return this.load()
      .then((data) => {
        this._current = angular.copy(data)
        return data
      })
  }

  /**
   * Lazy load in-app settings
   * Warning! Returns plain object, not instance of InappSettings!
   *
   * @memberof models.InappSettings
   * @return {Promise} promise
   */
  InappSettings.lazyLoad = function () {
    return this._current !== null
      ? $q.when(this._current)
      : this.forceLoad()
  }

  /**
   * Save in-app settings
   *
   * @memberof models.InappSettings
   * @param {Object} settings - in-app settings
   * @return {Promise} promise
   */
  InappSettings.save = function (settings) {
    const { guestModeSettings, inAppRegistrationSettings } = settings

    const checkingDisabling = (obj) => {
      if (!obj.enabled) {
        obj.network = null
        obj.subscription = null
      }
      return obj
    }

    return Promise.all([
      settings._save(model => { Object.assign(model, checkingDisabling(inAppRegistrationSettings)) }, '/nora/api/settings/login-options/in-app', null, null),
      settings._save(model => { Object.assign(model, checkingDisabling(guestModeSettings)) }, '/nora/api/settings/login-options/guest-mode', null, null)
    ])
      .then(() => {
        this._current = angular.copy(settings)
        return settings
      })
  }

  /**
   * Save in-app settings
   *
   * @memberof models.InappSettings
   * @param {Object} settings - in-app settings
   * @param {Number} networkId - in-app settings
   * @return {Promise} promise
   */
  InappSettings.saveForNetwork = function (settings, networkId) {
    const { guestModeSettings, inAppRegistrationSettings } = settings

    const checkingDisabling = (obj) => {
      if (!obj.enabled) {
        obj.subscription = null
      }
      return obj
    }

    return Promise.all([
      settings._save(model => { Object.assign(model, checkingDisabling(inAppRegistrationSettings)) }, `/nora/api/networks/${networkId}/settings/login-options/in-app`, null, null),
      settings._save(model => { Object.assign(model, checkingDisabling(guestModeSettings)) }, `/nora/api/networks/${networkId}/settings/login-options/guest-mode`, null, null)
    ])
      .then(() => {
        this._currsent = angular.copy(settings)
        return settings
      })
  }

  return InappSettings
}
